import HttpClient from "./HttpClient";

export default class Contact{
    constructor(contact){
        this.id = contact.id;
        this.name = contact.name;
        this.email = contact.email;
        this.mobile = contact.mobile;
        this.notify = contact.notify;
        this.customer_id = contact.customer_id;
        this.created_at = contact.created_at;
        this.updated_at = contact.updated_at
    }

    static async create(data){
        const client = new HttpClient();
        const response = await client.instance.post("contacts", data);
        return response.data;
    }

    static async update(id, data){
        const client = new HttpClient();
        const response = await client.instance.put(`contacts/${id}`, data);
        return response.data;
    }

    async delete(){
        const client = new HttpClient();
        const response = await client.instance.delete(`contacts/${this.id}`);
        return response.data;
    }
}